import authStore from '@/auth/auth.store'
import { FirebaseAuth } from '@/lib/auth'
import 'firebase/analytics'
import firebase from 'firebase/app'
import 'firebase/auth'

const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  INTERNAL_ERROR: 500
}

const conf = APP_CONFIG // eslint-disable-line

/* eslint-disable */
class SamlService {
  constructor() {

    const config = {
      apiKey: conf.firebase.apiKey,
      authDomain: conf.firebase.authDomain,
      databaseURL: conf.firebase.databaseURL,
      projectId: conf.firebase.projectId,
      storageBucket: conf.firebase.storageBucket,
      messagingSenderId: conf.firebase.messagingSenderId,
      appId: conf.firebase.appId,
      measurementId: conf.firebase.measurementId,
      application: conf.firebase.application
    }

    const app = firebase.initializeApp(config)
    firebase.analytics()

    this.authenticator = new FirebaseAuth(config, app, ['development', 'staging'].includes(process.env.NODE_ENV))
  }

  async authenticate({ skipAuth = false } = {}) {
    await this.authenticator
        .signIn()
        .then(fAuth =>
          fAuth.authorization().catch(authorizationError => {
            //error authorization
            console.warn('Error on authorization', authorizationError)
            window.location.href = '/forbidden.html'
          })
        )
        .catch(signInError => {
          //catch signIng
          console.warn('Error on authentification', signInError)
          window.location.href = '/forbidden.html'
        })
        .then(async({ firebaseUser, user, roles }) => {
          authStore.samlToken = firebaseUser.uid
          authStore.user = { ...user, userCode: user.uid }
          authStore.firebaseUser = firebaseUser
          authStore.roles = roles
        })
    return true
  }

  loadUser = data => {
    let user = null

    if (data && data.result) {
      user = data.result
      user.phone = user.phone ? user.phone.trim().replace('+33', '0') : null
      user.email = user.email ? user.email.trim() : null
      user.cguAccepted = +user.cguAccepted.trim() === 1
      user.emailOptin = +user.emailOptin.trim() === 1
      user.phoneOptin = +user.phoneOptin.trim() === 1
      user.birthday = user.birthday === '1001-01-01' ? null : user.birthday
    }

    return user
  }

  logout() {
    // FIXME Pas implemente pour le moment, apparemment c'est volontaire ? (cf Denis)
    //this.authenticator.redirectToSamlLogout()
    window.location = `${ process.env.BASE_URL }/login.html`
  }

  static redirectToForbidden() {
    // eslint-disable-next-line
    window.location = `${ process.env.BASE_URL }/forbidden.html`
  }

  static redirectToMaintenance() {
    // eslint-disable-next-line
    window.location = `${ process.env.BASE_URL }/maintenance.html`
  }
}

export default new SamlService()



// WEBPACK FOOTER //
// ./src/auth/saml.service.js